<div class="k-card" [class]="size" [ngClass]="{'responsive' :isResponsive,'highlightOnHover':highlightOnHover}">
    <ng-content></ng-content>
</div>